<template>
  <v-container
    id="user-list"
  >
  <v-form
  ref="form"
  @submit.prevent="insertCargos()"
  v-model="valid"
  lazy-validation
  >
    <v-row>
      <v-col>Cadastro de cargos e funcoes</v-col>
      <v-col
        class="text-right"
      >
        <v-btn
            name="voltar"
            outlined
            color="primary"
            class="ml-3"
            :to="'/sala-principal/:id/cargos-funcoes'"
          >
            Voltar para Lista de Cargos
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Nome do Cargo"
          name="nome"
          type="text"
          v-model="payload.nomeCargo"
          :rules="nomeRules"
          required
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Missão"
          name="nome"
          type="text"
          required
          v-model="payload.missao"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Orgão"
          name="email"
          type="email"
          required
          v-model="payload.orgao"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Numero Atual Interno"
          name="email"
          type="email"
          required
          v-model="payload.numeroAtualInterno"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Numero Atual Externo"
          name="email"
          type="email"
          required
          v-model="payload.numeroAtualExterno"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Numero Desejavel Interno"
          name="email"
          type="email"
          required
          v-model="payload.numeroDesejavelInterno"
        ></v-text-field>
      </v-col>
    </v-row>

     <v-row>
      <v-col>
        <v-text-field
          label="Numero Desejavel Externo"
          name="email"
          type="email"
          required
          v-model="payload.numeroDesejavelExterno"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-col
        cols="12"
        md="12"
      >
        <v-textarea
          name="input-7-1"
          label="Nome Ocupantes"
          hint="Hint text"
          v-model="payload.nomeOcupantes"
        ></v-textarea>
    </v-col>

    <v-col
        cols="12"
        md="12"
      >
        <v-textarea
          name="input-7-1"
          label="Serviços Executados"
          hint="Hint text"
          v-model="payload.servicosExecutados"
        ></v-textarea>
    </v-col>

    <v-col
        cols="12"
        md="12"
      >
        <v-textarea
          name="input-7-1"
          label="Serviços Não Executados"
          hint="Hint text"
          v-model="payload.servicosNaoExecutados"
        ></v-textarea>
    </v-col>

    <v-row>
      <v-col>
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          type="submit"
        >
          Cadastrar Cargo
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
  </v-container>
</template>

<script>
import { cargosFuncoes } from '../API/cargosFuncoesApi'
import { mapActions, mapGetters } from 'vuex'

export default {

  data () {
    return {
      payload: [
        {
          nomeCargo: null,
          municipioId: 0,
          missao: null,
          orgao: null,
          nomeOcupantes: null,
          servicosExecutados: null,
          servicosNaoExecutados: null,
          numeroAtualInterno: null,
          numeroAtualExterno: null,
          numeroDesejavelInterno: null,
          numeroDesejavelExterno: null
        }
      ],
      nomeRules: [
        v => !!v || 'O campo nome do cargo e obrigatório'
      ]
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    insertCargos () {
      if (this.$refs.form.validate()) {
        let formData = new FormData()

        formData.append('nomeCargo', this.payload.nomeCargo)
        formData.append('missao', this.payload.missao)
        formData.append('orgao', this.payload.orgao)
        formData.append('nomeOcupantes', this.payload.nomeOcupantes)
        formData.append('servicosExecutados', this.payload.servicosExecutados)
        formData.append('servicosNaoExecutados', this.payload.servicosNaoExecutados)
        formData.append('numeroAtualInterno', this.payload.numeroAtualInterno)
        formData.append('numeroAtualExterno', this.payload.numeroAtualExterno)
        formData.append('numeroDesejavelInterno', this.payload.numeroDesejavelInterno)
        formData.append('numeroDesejavelExterno', this.payload.numeroDesejavelExterno)
        formData.append('municipioId', this.$route.params.id)

        this.setLoading(true)
        cargosFuncoes.create(formData)
          .then(resp => {
            this.setLoading(false)
            this.$router.push('/sala-principal/:id/cargos-funcoes')
          })
          .catch(resp => {
            this.setLoading(false)
            this.$notification.error('Erro ao cadastrar os dados')
          })
      }
    }
  },
  computed: {
    ...mapGetters([
      'cityId'
    ])
  }
}
</script>
